import { useEffect, useCallback } from 'react';
import './PhotoViewer.css';

export default function PhotoViewer({ images, index, onClose, onNavigate }) {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowRight') onNavigate(1);
    if (e.key === 'ArrowLeft') onNavigate(-1);
  }, [onClose, onNavigate]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  if (!images || images.length === 0) return null;
  const current = images[index];

  return (
    <div className="photo-viewer-backdrop" onClick={onClose}>
      <button className="photo-viewer-close" onClick={onClose} aria-label="Close">×</button>

      {images.length > 1 && (
        <button
          className="photo-viewer-nav photo-viewer-prev"
          onClick={(e) => { e.stopPropagation(); onNavigate(-1); }}
          aria-label="Previous photo"
        >
          ‹
        </button>
      )}

      <div className="photo-viewer-content" onClick={(e) => e.stopPropagation()}>
        <img src={current.url} alt={current.caption || 'Photo'} />
        {(current.caption || images.length > 1) && (
          <div className="photo-viewer-info">
            {current.caption && <span className="photo-viewer-caption">{current.caption}</span>}
            {images.length > 1 && <span className="photo-viewer-count">{index + 1} / {images.length}</span>}
          </div>
        )}
      </div>

      {images.length > 1 && (
        <button
          className="photo-viewer-nav photo-viewer-next"
          onClick={(e) => { e.stopPropagation(); onNavigate(1); }}
          aria-label="Next photo"
        >
          ›
        </button>
      )}
    </div>
  );
}
